// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__K0dJo","container":"styles_container__bZt9V","wrapper":"styles_wrapper__3jK4Y","sliderCont":"styles_sliderCont__1GFOk"};